<template lang="pug">
div#nse-product-preview-mobile
    div.image
        img(:src="image" :class="image ? 'have-image' : 'no-image'")
    div.summary
        div.top-desc {{ LANG.MOBILE_DOUBLE_CHECK_PREVIEW }}
        div.title {{ productName }}


        div.additions-area
            template(v-if="openInfo")
                div.row-additions(v-for="field in fields")
                    span.label-text {{ field.l }}:
                    span.label-value()
                        span(v-html="field.v")

        slot
</template>

<style lang="scss">
    #nse-product-preview-mobile {
        .title {
            font-size: 16px;
            padding: 20px 0;
            margin-bottom: auto;
        }
        .confirm-bottom-bar {
            position: fixed;
            bottom: 0;
            width: 100%;
            left: 0;
            background-color: #fff;
            padding-bottom: 15px;
             >  * {
                padding-left: 15px;
                padding-right: 15px;
             }
        }
        .image {
            padding-top: 20px;
            img {
                max-height: 290px;
                width: auto;
                object-fit: contain;
                box-shadow: 1px 1px 7px rgb(0 0 0 / 10%);
            }
        }

        .additions-area {
            //max-height: 100px;
            overflow: auto;
        }

        .emoji {
            height: 1.1em;
        }

        .top-desc {
            padding: 20px 0;
            border-top: 1px solid #DADADA;
            border-bottom: 1px solid #DADADA;
            font-size: 14px;
        }
        .row-additions {
            padding: 4px 0;
        }
    }
</style>

<script>
import {computed, getCurrentInstance} from "vue";
import TextParse from "@/commons/TextParse";

export default {
	name: "ProductConfirmMobile",
	props: {
		price: {type: [Number, String]},
		selected: {
			type: Object
		},
		isShown: {
			type: Boolean,
			default: false
		},
		cartContext: {
			type: Object,
			default() {
				return {}
			}
		},
        image: {
		    type: String
        },
        fields: {
		    type:Array,
            default() {
                return []
            }
        }
	},
	emits: ["close"],
	setup(props, {emit}) {
		const finalPrice = computed(() => {
			return props.price
		});


		const sizeLabel = computed(() => {
			return props.selected.poster_size ? props.selected.poster_size.title : "";
		});

		const productName = computed(() => {
            var out = `${props.selected.poster_style.title} - ${props.selected.poster_size.title}`
            out = decodeURI(out)

			return out;
		});

		const srcImageClose = computed(() => {
			return window.nse_config.assets_url + "assets/image/close-popup.svg"
		});

		const closePopup = () => {
			emit('close');
		}

		const goto = (url) => {
			window.nse_app.redirect_to_add_cart = true;
			location.href = url;
		}


        const isMobile = computed(() => {
            return nse_app.isMobile
        })

        const openInfo = computed(() => {
		    if (!isMobile.value) return true;

		    return  true;
        });


        return {
			productName,
			finalPrice,
			srcImageClose,
			closePopup,
			sizeLabel,
			goto,
            isMobile,
            openInfo
		}
	}
}
</script>
